const headList = [
    {
        name:'注册人数',
        title:'registeredNum',
        icon:'iconfont registered icon icon-zhuce'
    },
    {
        name:'在线人数',
        title:'onlineNum',
        icon:'iconfont online icon icon-renshu'
    },
    {
        name:'浏览量',
        title:'views',
        icon:'iconfont icon views icon-liulanliang'
    },
    {
        name:'文章总量',
        title:'wzzl',
        icon:'iconfont icon classification icon-fenleigongnengleimu'
    },
]

export {
    headList
}